import React from 'react';
import { motion } from 'framer-motion';
import { CheckSquareIcon, TrashIcon, CalendarIcon } from 'lucide-react';
const steps = [{
  icon: CheckSquareIcon,
  text: 'Imprime el Checklist de 21 días'
}, {
  icon: TrashIcon,
  text: 'Limpia tu alacena de aceites vegetales y azúcares ocultos'
}, {
  icon: CalendarIcon,
  text: 'Empieza mañana. No el lunes. Mañana.'
}];
export function ClosingSection() {
  return <section className="py-16 md:py-24 bg-gradient-to-br from-sage-primary/20 to-cream" data-id="element-35">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-36">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-forest mb-8" data-id="element-37">
          Tu versión más ligera y vibrante te está esperando
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-forest/80 mb-12" data-id="element-38">
          Has dado el primer paso para recuperar el control de tu cuerpo. No
          eres una víctima de tu edad, eres la dueña de tu biología.
        </motion.p>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-39">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-md" data-id="element-40">
              <step.icon className="w-12 h-12 text-sage-dark mx-auto mb-4" data-id="element-41" />
              <p className="text-forest font-medium" data-id="element-42">{step.text}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-lg text-terracotta font-semibold" data-id="element-43">
          Este PDF es tu guía, pero tú eres el motor.
        </motion.p>
      </div>
    </section>;
}